export class UnimplementedMethod extends Error {}
export default UnimplementedMethod
